import React from 'react'
import styled from 'styled-components'

const Bold = styled.span`
  font-size: inherit;
  font-weight: bold;
`

export default Bold
